// Ensures the "Contact Sales@TonerWorldwide.com" message (rendered server-side
// for out-of-stock variants) is not overwritten by theme.Product's
// productVariantCallback, which unconditionally re-renders the price element
// on load and on variant change. Font size is reduced to 70% of the
// surrounding .h1 price size to match the server-rendered version.
(function() {
  if (window.theme && window.theme.Product && window.theme.Product.prototype && window.theme.Product.prototype.productVariantCallback) {
    var originalCallback = window.theme.Product.prototype.productVariantCallback;

    window.theme.Product.prototype.productVariantCallback = function(variant) {
      originalCallback.call(this, variant);

      if (variant && !variant.available) {
        this.settings.selectors.$productPrice.html('<span style="font-size: 70%;">Contact Sales@TonerWorldwide.com</span>');
        this.settings.selectors.$comparePrice.hide();
      }
    };
  }
})();
